import api from 'api/instance';
import { FetchResponse } from 'types/common';
import { Art } from 'types/art';

const URL = `${process.env.REACT_APP_API_URL}`;

type ArtByNumberResponse = {
  item?: Art;
  message?: string;
};

export const fetchArts = async () => {
  const { data } = await api.get<FetchResponse<Art>>(`${URL}/art/list`, {
    params: { limit: 1000 },
  });

  return data?.items ?? [];
};

export const fetchArtByNumber = async (number: string) => {
  const { data } = await api.get<ArtByNumberResponse>(`${URL}/art/by-number`, {
    params: { number },
  });

  if (!data?.item?._id) {
    throw new Error(data?.message || `Art not found for number "${number}"`);
  }

  return data.item;
};
